var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c(
        "nav",
        {
          staticClass:
            "navbar navbar-lg navbar-expand-lg navbar-dark bg-primary"
        },
        [
          _c(
            "div",
            { staticClass: "container-fluid" },
            [
              _c(
                "router-link",
                { staticClass: "navbar-brand", attrs: { to: "/user/landing" } },
                [_vm._v("\n        Scales\n      ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-white dropdown-toggle mr-2",
                    attrs: {
                      type: "button",
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false"
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("navbar.language")) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-menu" }, [
                  _c(
                    "button",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          return _vm.changeLanguage("en")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("languageChoice.English")) +
                          "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          return _vm.changeLanguage("zh")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("languageChoice.Chinese")) +
                          "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          return _vm.changeLanguage("jp")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("languageChoice.Japanese")) +
                          "\n          "
                      )
                    ]
                  )
                ])
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("main", { staticClass: "main", attrs: { role: "main" } }, [
        _c("div", { staticClass: "py-5 bg-light" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "col-md-12 p-0" }, [
              _c("div", { staticClass: "card mt-4 pt-3 pb-3" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "form",
                    {
                      staticClass:
                        "demo-ruleForm needs-validation-update-password",
                      attrs: { "label-width": "0px", novalidate: "" }
                    },
                    [
                      _c("div", { staticClass: "text-center pt-3 pb-3" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.$t("UpdatePasswordPage.Tips")) +
                            "\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group row no-gutters col-12 pb-3"
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "col-12 col-md-3 offset-md-1",
                              attrs: { for: "email" }
                            },
                            [_vm._v(_vm._s(_vm.$t("login.email")))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-md-8" }, [
                            _c("input", {
                              staticClass: "form-control",
                              attrs: { readonly: "", id: "email" },
                              domProps: { value: _vm.email }
                            })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group row no-gutters col-12 pb-3"
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "col-12 col-md-3 offset-md-1",
                              attrs: { for: "newPassword" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("UpdatePasswordPage.NewsPassword")
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-md-8" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.newPassword,
                                  expression: "newPassword"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "password",
                                maxlength: "128",
                                required: "",
                                id: "newPassword"
                              },
                              domProps: { value: _vm.newPassword },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.newPassword = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm.$t(
                                      "UpdatePasswordPage.ErrorPormptnewspad"
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group row no-gutters col-12 mb-0"
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "col-12 col-md-3 offset-md-1",
                              attrs: { for: "verifyPassword" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("UpdatePasswordPage.VerifyPassword")
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-md-8" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.verifyPassword,
                                  expression: "verifyPassword"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "password",
                                maxlength: "128",
                                required: "",
                                id: "verifyPassword"
                              },
                              domProps: { value: _vm.verifyPassword },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.verifyPassword = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm.$t(
                                      "UpdatePasswordPage.ErrorPormptVerify"
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "invalid-feedback password-not-match",
                                staticStyle: { display: "none" }
                              },
                              [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm.$t("UpdatePasswordPage.notMatch")
                                    ) +
                                    "\n                    "
                                )
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "row justify-content-end mt-4 col-12 pr-0"
                        },
                        [
                          _c("div", { staticClass: "col-6 text-right pr-0" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: {
                                  disabled:
                                    _vm.email === null || _vm.email === ""
                                },
                                on: { click: _vm.update }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("UpdatePasswordPage.Changebtn"))
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("copyright")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15126d5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15126d5a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/forget-password.vue
// module id = null
// module chunks = 